import Login from '@/pages/Auth/Login';
import NewPassword from '@/pages/Auth/NewPassword';
import VerfiyOtp from '@/pages/Auth/VerifyOtp';
import Dashboard from '@/pages/Dashboard/Dashboard';
import LeaveSetting from '@/pages/HRM/HrmSettings/LeaveSetting/LeaveSetting';
import AddOffice from '@/pages/HRM/HrmSettings/OfficeLocation/AddOffice';
import OfficeLocation from '@/pages/HRM/HrmSettings/OfficeLocation/OfficeLocation';
import SalaryHead from '@/pages/HRM/HrmSettings/SalaryHead.tsx/SalaryHead';
import AddShiftAndTime from '@/pages/HRM/HrmSettings/ShiftAndTime/AddShiftAndTime';
import ShiftAndTimeConfig from '@/pages/HRM/HrmSettings/ShiftAndTime/ShiftAndTimeConfig';
import AddCompany from '@/pages/sites/company/AddCompany';
import Company from '@/pages/sites/company/Company';
import CompanyDetail from '@/pages/sites/company/CompanyDetail';
import { RoutesLink } from '@/utility/RouteLinks';
import { Route, Routes } from 'react-router-dom';
import AddLeaveSetting from '@/pages/HRM/HrmSettings/LeaveSetting/AddLeaveSetting';
import HolidaySetting from '@/pages/HRM/HrmSettings/Holiday/HolidaySetting';
import AddSalaryHead from '@/pages/HRM/HrmSettings/SalaryHead.tsx/AddSalaryHead';
import Designation from '@/pages/HRM/HrmSettings/Designation/Designation';
import Department from '@/pages/HRM/HrmSettings/Department/Department';
import AddDesignation from '@/pages/HRM/HrmSettings/Designation/AddDesignation';
import UnderDevelopmentPage from '@/pages/CommonPages/UnderDevelopment';
// import ProtectedRoute from '@/pages/Auth/ProtectedRoute';
import MyAttendance from '@/pages/HRM/Attendance/MyAttendance';
import EmployeeOnBoard from '@/pages/HRM/HrmSettings/EmployeeOnboard/EmployeeOnBoard';
import MonthlyTeamAttendance from '@/pages/HRM/Attendance/MonthlyTeamAttendance';
import EmployeeDetail from '@/pages/HRM/HrmSettings/EmployeeOnboard/EmployeeDetail';
import MyRegularization from '@/pages/HRM/Regularization/MyRegularization';
import TeamAttendance from '@/pages/HRM/Attendance/TeamAttendance';
import ManageBulkAtt from '@/pages/HRM/Attendance/ManageBulkAtt';
import MyWfh from '@/pages/HRM/WFH/MyWfh';
import TeamWfh from '@/pages/HRM/WFH/TeamWfh';
import ArRequestDetail from '@/pages/HRM/Regularization/ArRequestDetail';
// import TeamRegularization from '@/pages/HRM/Regularization/TeamRegularization.tsx';
import AddEmployeeOnBoard from '@/pages/HRM/HrmSettings/EmployeeOnboard/AddEmployeeOnBoard';
import WfhRequestDetail from '@/pages/HRM/WFH/WfhRequestDetail';
import { permissionKeys } from '@/utility/helper';
import ProtectedLoginRoute from '@/pages/Auth/ProtectedLoginRoute';
import MyLeave from '@/pages/HRM/Leave/MyLeave';
import NotFoundPage from '@/pages/CommonPages/NotFoundPage';
import TeamLeave from '@/pages/HRM/Leave/TeamLeave';
import AddLeave from '@/pages/HRM/Leave/AddLeave';
import Holidays from '@/pages/HRM/Holidays/Holidays';
import LeaveDetail from '@/pages/HRM/Leave/LeaveDetail';
import MySlips from '@/pages/HRM/Payslips/MyPayslips';
import TeamPayslips from '@/pages/HRM/Payslips/TeamPayslips';
import Profile from '@/pages/Profile/Profile';
import UpdateProfile from '@/pages/Profile/UpdateProfile';
import SalaryConfig from '@/pages/HRM/HrmSettings/SalaryConfig/SalaryConfig';
import SiteSalaryHead from '@/pages/HRM/HrmSettings/SiteSalaryHead/SiteSalaryHead';
import Notification from '@/pages/Notification/Notification';
import ProtectedRoute from '@/pages/Auth/ProtectedRoute';
import AddSiteSalaryHead from '@/pages/HRM/HrmSettings/SiteSalaryHead/AddSiteSalaryHead';
import PayslipOfficeWise from '@/pages/HRM/Payslips/PayslipOfficeWise';
import AttendanceLogs from '@/pages/HRM/Attendance/AttendanceLogs';
import BiometricDevices from '@/pages/HRM/BiometricDevices/BiometricDevices';
import AssetsRequest from '@/pages/HRM/AssetsRequest/AssetsRequest';
import AssetsCategory from '@/pages/HRM/HrmSettings/AssetsCategory/AssetsCategory';
import AddAsset from '@/pages/HRM/HrmSettings/Assets/AddAsset';
import AssetDetail from '@/pages/HRM/HrmSettings/Assets/AssetDetail';
import AssetRequests from '@/pages/HRM/HrmSettings/AssetRequests/AssetRequests';
import Policy from '@/pages/HRM/HrmSettings/Policy/Policy';
import Assets from '@/pages/HRM/HrmSettings/Assets/Assets';
import AssetCategoryDetail from '@/pages/HRM/HrmSettings/AssetsCategory/AssetCategoryDetail';
import DetailEmployee from '@/pages/HRM/Employees/DetailEmployee';
import TeamRegularization from '@/pages/HRM/Regularization/TeamRegularization';
import Forms from '@/pages/HRM/HrmSettings/Forms/Forms';
import FormBuilder from '@/pages/HRM/HrmSettings/Forms/FormBuilder/FormBuilder';
import FormView from '@/pages/HRM/HrmSettings/Forms/FormView';

const CommonRoutes = () => {
  const privateRoutes = [
    // {
    //   path: RoutesLink?.dashboard,
    //   element: <Dashboard />,
    //   key: permissionKeys?.dashboard,
    // },
    {
      path: RoutesLink?.addCompany,
      element: <AddCompany />,
      key: permissionKeys?.company,
    },
    {
      path: RoutesLink?.companyDetail + '/:id',
      element: <CompanyDetail />,
      key: permissionKeys?.company,
    },
    {
      path: RoutesLink?.editCompany + '/:id',
      element: <AddCompany />,
      key: permissionKeys?.company,
    },
    {
      path: RoutesLink?.company,
      element: <Company />,
      key: permissionKeys?.company,
    },
    {
      path: RoutesLink?.officeLocation,
      element: <OfficeLocation />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink?.addOffice,
      element: <AddOffice />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink?.shifts,
      element: <ShiftAndTimeConfig />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink?.addShift,
      element: <AddShiftAndTime />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink?.leaveSetting,
      element: <LeaveSetting />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink?.addLeaveSetting,
      element: <AddLeaveSetting />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink?.holiday,
      element: <HolidaySetting />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink?.salaryHead,
      element: <SalaryHead />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink?.addSalaryHead,
      element: <AddSalaryHead />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink?.department,
      element: <Department />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink?.desgination,
      element: <Designation />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink?.addDesignation,
      element: <AddDesignation />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink?.attendance,
      element: <MyAttendance />,
      key: permissionKeys?.attendance,
    },
    {
      path: RoutesLink?.teamAttendance,
      element: <TeamAttendance />,
      key: permissionKeys?.attendance,
    },
    {
      path: RoutesLink?.monthlyTeamAttendance,
      element: <MonthlyTeamAttendance />,
      key: permissionKeys?.attendance,
    },
    {
      path: RoutesLink.monthlyTeamAttendanceDetail + '/:id',
      element: <MyAttendance />,
      key: permissionKeys?.attendance,
    },
    {
      path: RoutesLink.attendanceLogs,
      element: <AttendanceLogs />,
      key: permissionKeys?.attendance,
    },
    {
      path: RoutesLink.manageBulkAttendance,
      element: <ManageBulkAtt />,
      key: permissionKeys?.attendance,
    },
    {
      path: RoutesLink.employeeOnBoard,
      element: <EmployeeOnBoard />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.policy,
      element: <Policy />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.addEmployeeOnBoard,
      element: <AddEmployeeOnBoard />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.editEmployeeOnBoard + '/:id',
      element: <AddEmployeeOnBoard />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.myWfh,
      element: <MyWfh />,
      key: permissionKeys?.wfh,
    },
    {
      path: RoutesLink.wfhRequestDetail + '/:id',
      element: <WfhRequestDetail />,
      key: permissionKeys?.wfh,
    },
    {
      path: `${RoutesLink.wfhTeamRequestDetail}/:id`,
      element: <WfhRequestDetail />,
      key: permissionKeys?.wfh,
    },
    {
      path: RoutesLink.teamWfh,
      element: <TeamWfh />,
      key: permissionKeys?.wfh,
    },
    {
      path: RoutesLink.assetsCategory,
      element: <AssetsCategory />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.assets + '/:id',
      element: <Assets />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.assets,
      element: <Assets />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.employeeDetail + '/:id',
      element: <EmployeeDetail />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.siteSalaryHead,
      element: <SiteSalaryHead />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.myRegularization,
      element: <MyRegularization />,
      key: permissionKeys?.regularization,
    },
    {
      path: RoutesLink.arRequestDetail + '/:id',
      element: <ArRequestDetail />,
      key: permissionKeys?.regularization,
    },
    {
      path: RoutesLink.arTeamRequestDetail + '/:id',
      element: <ArRequestDetail />,
      key: permissionKeys?.regularization,
    },
    {
      path: RoutesLink.assetsRequest,
      element: <AssetsRequest />,
      key: permissionKeys?.assets,
    },
    {
      path: RoutesLink.teamAr,
      element: <TeamRegularization />,
      key: permissionKeys?.regularization,
    },
    {
      path: RoutesLink.myLeave,
      element: <MyLeave />,
      key: permissionKeys?.leave,
    },
    {
      path: RoutesLink.holidays,
      element: <Holidays />,
      key: permissionKeys?.holiday,
    },
    {
      path: RoutesLink.teamLeave,
      element: <TeamLeave />,
      key: permissionKeys?.leave,
    },
    {
      path: RoutesLink.addLeave,
      element: <AddLeave />,
      key: permissionKeys?.leave,
    },
    {
      path: RoutesLink.addSiteSalaryHead,
      element: <AddSiteSalaryHead />,
      key: permissionKeys.hrmSetting,
    },

    {
      path: `${RoutesLink.leaveDetail}/:id`,
      element: <LeaveDetail />,
      key: permissionKeys?.leave,
    },
    {
      path: `${RoutesLink.leaveTeamDetail}/:id`,
      element: <LeaveDetail />,
      key: permissionKeys?.regularization,
    },
    {
      path: RoutesLink.salaryConfig,
      element: <SalaryConfig />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.myPaySlip,
      element: <MySlips />,
      key: permissionKeys?.payslip,
    },
    {
      path: RoutesLink.teamPayslips,
      element: <TeamPayslips />,
      key: permissionKeys?.payslip,
    },
    {
      path: RoutesLink.payslipOfficeWise + '/:id',
      element: <PayslipOfficeWise />,
      key: permissionKeys?.payslip,
    },
    {
      path: RoutesLink.biometricDevices,
      element: <BiometricDevices />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.addAsset + `/:id`,
      element: <AddAsset />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.addAsset,
      element: <AddAsset />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.assetDetail + '/:id',
      element: <AssetDetail />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.assetRequests,
      element: <AssetRequests />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.assetCategoryDetail + '/:id',
      element: <AssetCategoryDetail />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.forms,
      element: <Forms />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: RoutesLink.formBuilder,
      element: <FormBuilder />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: `${RoutesLink.editForm}/:id`,
      element: <FormBuilder />,
      key: permissionKeys?.hrmSetting,
    },
    {
      path: `${RoutesLink.formView}/:id`,
      element: <FormView />,
      key: permissionKeys?.hrmSetting,
    },
  ];

  return (
    <Routes>
      {/* Auth */}
      <Route element={<ProtectedLoginRoute />}>
        <Route path={RoutesLink?.Login} element={<Login />} />
        {/* <Route path={RoutesLink?.forgetPassword} element={<ForgetPassword />} /> */}
        <Route path={RoutesLink?.verifyOtp} element={<VerfiyOtp />} />
        <Route path={RoutesLink?.newPassword} element={<NewPassword />} />
      </Route>
      {privateRoutes?.map((route, index) => (
        <Route
          key={index}
          path={route?.path}
          element={
            <ProtectedRoute keys={route?.key}>{route?.element}</ProtectedRoute>
          }
        />
      ))}
      {/* Dashboard */}
      <Route
        path={RoutesLink?.dashboard}
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.employees}
        element={
          <ProtectedRoute>
            <EmployeeOnBoard />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.detailEmployee + '/:id'}
        element={
          <ProtectedRoute>
            <DetailEmployee />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.profile}
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.updateProfile}
        element={
          <ProtectedRoute>
            <UpdateProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.notification}
        element={
          <ProtectedRoute>
            <Notification />
          </ProtectedRoute>
        }
      />

      {/* 
      <Route
        path={RoutesLink?.addCompany}
        element={
          <ProtectedRoute>
            <AddCompany />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.companyDetail + '/:id'}
        element={
          <ProtectedRoute>
            <CompanyDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.editCompany + '/:id'}
        element={
          <ProtectedRoute>
            <AddCompany />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.company}
        element={
          <ProtectedRoute>
            <Company />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.officeLocation}
        element={
          // <ProtectedRoute>
          <OfficeLocation />
          // </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.addOffice}
        element={
          // <ProtectedRoute>
          <AddOffice />
          // </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.shifts}
        element={
          <ProtectedRoute>
            <ShiftAndTimeConfig />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.addShift}
        element={
          <ProtectedRoute>
            <AddShiftAndTime />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.leaveSetting}
        element={
          <ProtectedRoute>
            <LeaveSetting />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.addLeaveSetting}
        element={
          <ProtectedRoute>
            <AddLeaveSetting />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.holiday}
        element={
          // <ProtectedRoute>
          <HolidaySetting />
          // </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.salaryHead}
        element={
          <ProtectedRoute>
            <SalaryHead />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.addSalaryHead}
        element={
          <ProtectedRoute>
            <AddSalaryHead />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.department}
        element={
          <ProtectedRoute>
            <Department />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.desgination}
        element={
          <ProtectedRoute>
            <Designation />
          </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.addDesignation}
        element={
          <ProtectedRoute>
            <AddDesignation />
          </ProtectedRoute>
        }
      />
      
      <Route
        path={RoutesLink?.attendance}
        element={
          // <ProtectedRoute>
          <MyAttendance />
          // </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.employeeOnBoard}
        element={
          // <ProtectedRoute>
          <EmployeeOnBoard />
          // </ProtectedRoute>
        }
      />{' '}
      <Route
        path={RoutesLink?.addEmployeeOnBoard}
        element={
          // <ProtectedRoute>
          <AddEmployeeOnBoard />
          // </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink.editEmployeeOnBoard + '/:id'}
        element={
          // <ProtectedRoute>
          <AddEmployeeOnBoard />
          // </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink.editEmployeeOnBoard + '/:id'}
        element={
          // <ProtectedRoute>
          <AddEmployeeOnBoard />
          // </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.teamAttendance}
        element={
          // <ProtectedRoute>
          <TeamAttendance />
          // </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.monthlyTeamAttendance}
        element={
          // <ProtectedRoute>
          <MonthlyTeamAttendance />
          // </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink?.monthlyTeamAttendance}
        element={
          // <ProtectedRoute>
          <MonthlyTeamAttendance />
          // </ProtectedRoute>
        }
      />
      <Route
        path={RoutesLink.monthlyTeamAttendanceDetail + '/:id'}
        element={<MyAttendance />}
      />
      <Route
        path={RoutesLink?.manageBulkAttendance}
        element={<ManageBulkAtt />}
      />
      <Route path={RoutesLink?.myWfh} element={<MyWfh />} />
      <Route
        path={RoutesLink.wfhRequestDetail + '/:id'}
        element={<WfhRequestDetail />}
      />
      <Route path={RoutesLink?.addWfhRequest} element={<AddWfhRequest />} />
      <Route path={RoutesLink?.teamWfh} element={<TeamWfh />} />
      <Route
        path={RoutesLink?.employeeDetail + '/:id'}
        element={<EmployeeDetail />}
      />
      <Route
        path={RoutesLink?.myRegularization}
        element={<MyRegularization />}
      />
      <Route
        path={RoutesLink?.arRequestDetail + '/:id'}
        element={<ArRequestDetail />}
      />
      <Route path={RoutesLink?.teamAr} element={<TeamRegularization />} /> */}
      <Route
        path={RoutesLink.underDevelopmentPage}
        element={
          // <ProtectedRoute>
          <UnderDevelopmentPage />
          // </ProtectedRoute>
        }
      />
      <Route path={'*'} element={<NotFoundPage />} />
    </Routes>
  );
};
export default CommonRoutes;
